import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';
import { postCreateFloorplanPlacement } from 'store/floorplans/services/postCreateFloorplanPlacement.service';

/**
 * Fetch device floorplan placements
 * API: GET /projects/{projectId}/sensor-floorplan-placements
 */
export const fetchDeviceFloorplanPlacements = async ({ projectId }) => {
  const apiPath = `projects/${projectId}/sensor-floorplan-placements`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data?.placements || [];
};

/**
 * Create a new device floorplan placement
 * API: POST /projects/{projectId}/floorplan-placements
 */
export const createDeviceFloorplanPlacement = async ({
  projectId,
  deviceId,
  floorplanId,
  x,
  y,
}) => {
  const response = await postCreateFloorplanPlacement(projectId, {
    deviceId,
    floorplanId,
    x,
    y,
    entityType: 'sensor',
  });
  return response;
};
